<div class="animated container-fluid container-filter">
    <form class="needs-validation" [formGroup]="form" novalidate>

        <h4>Documentación para Campaña Específica</h4>

        <div class="row">
            <div class="col-md-12">

                <div class="row">

                    <div class="col-md-12">
                        <div class="card card-accent-success animated fadeIn">
                            <a class="card-header-a" (click)="isCollapsedCabecera = !isCollapsedCabecera" [attr.aria-expanded]="!isCollapsedCabecera" aria-controls="collapseCabecera">
                                <div class="card-header-buscador">
                                    <i class="fa fa-file-text-o"></i> Datos de Campaña y Documentación
                                    <i *ngIf="isCollapsedCabecera" class="fa fa-caret-down float-right"></i>
                                    <i *ngIf="!isCollapsedCabecera" class="fa fa-caret-up float-right"></i>
                                </div>
                            </a>
                            <div class="card-body-detalle">
                                <div class="collapse group-filtros" id="collapsedCabecera" [ngbCollapse]="isCollapsedCabecera">

                                    <div class="row">

                                        <div class="form-group col-md-6">
                                            <label class="col-form-label" for="intCampaniaDescripcion">Campaña</label>
                                            <input formControlName="IdCampaniaDescripcion" name="IdCampaniaDescripcion" class="form-control" inputStyleClass="form-control" [ngClass]="displayFieldCss('IdCampaniaDescripcion')" type="text" value="" aria-describedby="validationDescriptionFeedback" readonly>
                                        </div>

                                        <div class="form-group col-md-6">
                                            <label class="col-form-label required-field" for="inpAdjuntarDocumentacion">Adjuntar documentación</label>
                                            <p-toggleButton class="form-control-togglebutton" formControlName="AdjuntarDocumentacion" onLabel="Sí" offLabel="NO" onIcon="pi pi-check" offIcon="pi pi-times" (click)="markAllToDelete()"></p-toggleButton>
                                        </div>

                                        <div class="form-group col-md-6">
                                            <label class="col-form-label" for="IdTipoDocumentacion">Tipo de Documentación</label>
                                            <ng-select appendTo="body"
                                                       [items]="tiposDocumentacionCam"
                                                       bindLabel="Descripcion"
                                                       bindValue="Id"
                                                       formControlName="IdTipoDocumentacion"
                                                       loadingText="Cargando..."
                                                       [loading]="!tiposDocumentacionCam"
                                                       placeholder="-- Seleccione un Tipo de Documentación --"
                                                       [ngClass]="displayFieldCssNgSelect('IdTipoDocumentacion')"
                                                       notFoundText="Tipo de Documentación no encontrado"
                                                       clearAllText="Eliminar selección">
                                                <ng-template ng-option-tmp let-item="item">
                                                    <div container="body" ngbTooltip="{{ item.Descripcion }}">{{ item.Descripcion }}</div>
                                                </ng-template>
                                            </ng-select>
                                        </div>

                                        <div class="form-group col-md-2">
                                            <label class="col-form-label" for="inpObligatoria">Documentación obligatoria</label>
                                            <p-toggleButton class="form-control-togglebutton" formControlName="Obligatoria" onLabel="Sí" offLabel="NO" onIcon="pi pi-check" offIcon="pi pi-times"></p-toggleButton>
                                        </div>

                                        <div class="btn-group col-md-1">
                                            <button name="btnAddTipoDocumentacionCam" class="btn btn-secondary btn-sm" type="submit" title="Añade un Tipo de Documentación" (click)="addNewDocumentation()" [disabled]="form.value.AdjuntarDocumentacion === false || !form.value?.IdTipoDocumentacion">
                                                <i class="fa fa-plus"></i> Añadir
                                            </button>
                                        </div>

                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

            </div>
        </div>
    </form>
</div>
